import React from "react"
import { Hole, HoleSkin } from "../types"
import { money, scoreName } from "../util"

interface SkinsProps {
  skins: Map<Hole, HoleSkin>
}

export default function Skins({ skins }: SkinsProps) {
  return (
    <table>
      <thead>
        <tr>
          <th>Hole</th>
          <th>Player</th>
          <th className="right">Score</th>
          <th className="right">Won</th>
        </tr>
      </thead>
      <tbody>
        {Array.from(skins.keys()).sort((a, b) => a.number < b.number ? -1 : 1).map((hole) => {
          const skin = skins.get(hole)

          return <tr key={hole.id}>
            <td>{hole.number}</td>
            <td>
              {skin.users.length === 1 ? skin.users[0].name : `${skin.users.length} tied`}
            </td>
            <td className="right">{scoreName(skin.score)}</td>
            <td className="right">{skin.amount ? money(skin.amount) : '--'}</td>
          </tr>
        })}
      </tbody>
    </table>
  )
}
